import {MinimumValue} from "../MinimumValue";
import {sprintf} from 'sprintf-js';
import {ValidatorInterface} from "../ValidatorInterface";
import {ArrayContains} from "../ArrayContains";
import {IModel} from "makerjs";
import AbstractValidatorSet from "./AbstractValidatorSet";
import Length from "../../../../../source/js/shared/models/Geometry/Length";
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";

export default class EdgeDrillHoleValidatorSet extends AbstractValidatorSet {
	private readonly minHoleDiameter: Length;
	private readonly state;
	private readonly drillHoleConfig;
	private readonly drillHoles: IModel;
	private readonly parentModel: IModel;

	constructor( minHoleDiameter: Length, state, drillHoleConfig: object, drillHoles: IModel, parentModel: IModel ) {
		super();

		this.minHoleDiameter = minHoleDiameter;
		this.state = state;
		this.drillHoleConfig = drillHoleConfig;
		this.drillHoles = drillHoles;
		this.parentModel = parentModel;
	}

	getValidators(): ValidatorInterface[] {
		const { drillHole } = window.measurementSelectorVariables.i18n.validators;
		const additionalValidators = [];

		if ( this.drillHoleConfig.edgeType === 'around' ) {
			additionalValidators.push(
				new ArrayContains( {
					field: 'edges',
					dimension: 'edges',
					items: this.drillHoleConfig.edges,
					condition: function ( edge ): boolean {
						return edge === 0;
					},
					customMessage: drillHole.edges.undefined_around_edges,
					invert: true
				} )
			);
		}

		return [
			new MinimumValue( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: this.state.drillHoleDiameter,
				minimum: this.minHoleDiameter.in_mm(),
				customMessage: sprintf( drillHole.diameter.min, this.minHoleDiameter.in_cm_i18n() )
			} ),
			new MaximumDecimalPoints( {
				field: 'drillHoleOffset',
				dimension: 'drillHoleOffset',
				value: new Length( this.state.drillHoleOffset ).in_cm(),
				customMessage: sprintf( drillHole.offset.decimals, 1 ) } ),
			new MaximumDecimalPoints( {
				field: 'drillHoleDiameter',
				dimension: 'drillHoleDiameter',
				value: new Length( this.state.drillHoleDiameter ).in_cm(),
				customMessage: sprintf( drillHole.diameter.decimals, 1 ) } ),
			...additionalValidators,
		];
	}
}
